import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { BehaviorSubject, Subject } from 'rxjs';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';
import { AutorizacionPresencialService } from 'src/app/_services/autorizacion-presencial.service';
import { AutorizacionPresencialCrearComponent } from '../autorizacion-presencial-crear/autorizacion-presencial-crear.component';
import { AutorizacionPresencialEliminarComponent } from '../autorizacion-presencial-eliminar/autorizacion-presencial-eliminar.component';

@Component({
  selector: 'app-autorizacion-presencial',
  standalone: false,
  templateUrl: './autorizacion-presencial.component.html',
  styleUrls: ['./autorizacion-presencial.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutorizacionPresencialComponent implements OnInit {

  @Input()
  alumno: any;
  @Input()
  autorizaciones: any[];
  @Input()
  edicion = true;

  autorizacionSubject = new BehaviorSubject<any | boolean>(false);
  autorizacion$ = this.autorizacionSubject.asObservable();

  isDisabled = true;

  constructor(
    private matDialogRef: MatDialog,
    private autorizacionPresencial: AutorizacionPresencialService,
    private customAlert: CustomAlertService
    ) {
  }

  ngOnInit(): void {
    // TODO: Definir propiedad.
    const autorizacionPresencial = this.autorizaciones.find(item => item.tipoOrigen === 301);
    if (autorizacionPresencial) {
      if (moment(autorizacionPresencial.fechaInicio) < moment()) {
        this.isDisabled = false;
      }
      this.autorizacionSubject.next({
        fecha: autorizacionPresencial.fechaInicio
      });
    }
  }

  eliminarAutorizacion() {
    const dialogo = this.matDialogRef.open(AutorizacionPresencialEliminarComponent, {
      data: {
        alumno: this.alumno
      }
    });
    const sub = dialogo.componentInstance['onSave$'].subscribe((res) => {
      this.autorizacionPresencial.eliminarAutorizacion(this.alumno).subscribe(respuesta => {
        this.isDisabled = true;
        this.autorizacionSubject.next(false);
        dialogo.close();
      },
      err => {
        this.customAlert.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible borrar la autorización. ${err.error}. <br> Código de error: ${err.statusText}`
        });
        dialogo.close();
      });
    });
    dialogo.afterClosed().subscribe(() => {
      sub.unsubscribe();
    });
  }

  autorizarPresencial() {
    const dialogo = this.matDialogRef.open(AutorizacionPresencialCrearComponent, {
      data: {
        alumno: this.alumno
      }
    });
    const sub = dialogo.componentInstance['onSave$'].subscribe(res => {
      this.autorizacionPresencial.crearAutorizacion(this.alumno, res).subscribe(respuesta => {
        if (moment(res) < moment()) {
          this.isDisabled = false;
        }
        this.autorizacionSubject.next({
          fecha: res
        });
        dialogo.close();
      },
      err => {
        this.customAlert.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible crear la autorización. ${err.error}. <br> Código de error: ${err.statusText}`
        });
      });
    });
    dialogo.afterClosed().subscribe(() => {
      sub.unsubscribe();
    });
  }

}
